<template>
  <el-checkbox-group v-model="departmentIds">
    <el-checkbox
      v-for="row in list"
      :key="row.departmentId"
      :label="row.departmentId">{{ row.departmentName }}</el-checkbox>
  </el-checkbox-group>
</template>
<script>
// import _ from 'lodash'
export default {
  name: 'DepartmentCheckbox',
  components: {},
  props: {
    value: {
      required: true
    },
    option: {
      type: Object,
      default() {
        return {
          pageNum: 1,
          pageSize: 1000,
          isSaleBranch: 1
        }
      }
    }
  },
  data() {
    return {
      list: []
    }
  },
  computed: {
    departmentIds: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    }
  },
  mounted() {
    this.fetchList()
  },
  methods: {
    fetchList() {
      this.$store.dispatch('vendor/getdepartments', {
        payload: this.option,
        success: (res) => {
          this.list = res.data.records
        },
        fail: () => {
          this.list = []
        }
      })
    }
  }
}
</script>
